import { Autocomplete, TextField, Typography } from '@mui/material';
import { ATSConnectImportCandidateFormTestIds } from 'data-testids/ATS';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { ErrorText, Key, SubContainer } from '../../../styles/hiringRequestStyles';
import { useEffect, useMemo } from 'react';
import { School } from 'types/types';

export const SchoolSelectorSubcontainer: React.FC = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const selectedRole = useWatch({ name: 'role' });

  const schools: School[] = useMemo(() => {
    if (!selectedRole?.schoolroles) return [];
    return selectedRole.schoolroles.map((sr) => sr.school).filter(Boolean);
  }, [selectedRole]);

  useEffect(() => {
    if (schools.length === 1) {
      setValue('school', schools[0]);
    } else {
      setValue('school', null);
    }
  }, [schools, setValue]);

  if (schools.length === 0) {
    return (
      <SubContainer data-testid={ATSConnectImportCandidateFormTestIds.SCHOOL_SELECTOR_CONTAINER}>
        <Typography
          data-testid={ATSConnectImportCandidateFormTestIds.SCHOOL_SELECTOR_NO_SCHOOLS_MESSAGE}
          color="text.secondary"
        >
          There are no schools associated with this role.
        </Typography>
      </SubContainer>
    );
  }

  return (
    <SubContainer data-testid={ATSConnectImportCandidateFormTestIds.SCHOOL_SELECTOR_CONTAINER}>
      <Key>Which school is this hiring request for?</Key>
      <Controller
        name="school"
        control={control}
        shouldUnregister
        rules={{ required: 'Please select a school' }}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            data-testid={ATSConnectImportCandidateFormTestIds.SCHOOL_SELECTOR}
            onChange={(_event, newValue: School) => onChange(newValue)}
            options={schools}
            value={value || null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} placeholder="Select a school" />}
          />
        )}
      />
      {errors.school && <ErrorText>{errors.school.message as string}</ErrorText>}
    </SubContainer>
  );
};
